import React from 'react'
import {CreateAccountForm} from '../components/indexComponents';

function CreateAccountPage() {
  return (
    <div className="App">
      <CreateAccountForm />
    </div>
  )
}

export default CreateAccountPage